import uniq from 'lodash/uniq';
import { hasRequiredFields } from '.';
import { requiredJobFields } from '../../constants';

const XLSX = require('xlsx');

export const validateXLSXUpload = xlsxUpload => {
  const workbook = XLSX.read(xlsxUpload, { type: 'binary', cellDates: true });
  const sheetName = workbook.SheetNames[0];
  const worksheet = workbook.Sheets[sheetName];

  const csv = XLSX.utils.sheet_to_csv(worksheet);
  const headers = csv?.match(/[^\n]*/)[0]?.split(',');
  const missingHeaders = requiredJobFields.filter(r => !(headers || []).includes(r));
  if (missingHeaders.length) {
    return { missing: [], missingFields: missingHeaders };
  }

  const xlsxJSON = XLSX.utils.sheet_to_json(worksheet);
  const fieldCheck = hasRequiredFields(xlsxJSON);
  return !fieldCheck.missing && !fieldCheck.missingFields ? fieldCheck.jobs : { missing: uniq(fieldCheck.missing), missingFields: [] };
};
